module.exports = __webpack_public_path__ + "img/场景展示.06879256.webp";